module.exports = __webpack_public_path__ + "static/img/technology-1-SD-WAN-img-2.d49b988.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/technology-1-SD-WAN-img-2.svg
// module id = JsMg
// module chunks = 0